/**
 * @generated SignedSource<<6f619671c95494c6eadcb8a2d7b24df0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileMatchBottomSheet_toProfile$data = {
  readonly name: string;
  readonly rowId: any;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile">;
  readonly " $fragmentType": "ProfileMatchBottomSheet_toProfile";
};
export type ProfileMatchBottomSheet_toProfile$key = {
  readonly " $data"?: ProfileMatchBottomSheet_toProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileMatchBottomSheet_toProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileMatchBottomSheet_toProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileAvatar_profile"
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "c672b0d2732fd5e98ef8a6a211d027d9";

export default node;
